import { render, staticRenderFns } from "./DnsCreate.vue?vue&type=template&id=35e9e6ea"
import script from "./DnsCreate.vue?vue&type=script&lang=js"
export * from "./DnsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports